import CompanyQuoteNews from './CompanyQuoteNews'
// Uncomment the below to migrate to stateful component
// import CompanyQuoteNewsContainer from './CompanyQuoteNewsContainer'

export { CompanyQuoteNews }
export default CompanyQuoteNews
// Uncomment the below to migrate to stateful component
// export { CompanyQuoteNewsContainer }
// export default { CompanyQuoteNewsContainer }
